<app-payments-info-dialog
  class="paypal-info-dialog"
  [dialogType]="dialogType"
  [headerLabel]="'LABEL.PAYPAL' | translate"
  [introLabel]="introLabel"
  [confirmLabel]="'ACTION.LEARN_MORE' | translate"
  [confirmUrl]="confirmUrl"
  [listItems]="listItems"
  [trackingObject]="trackingObject"
  [trackingScreenName]="trackingScreenName"
  (onConfirm)="onConfirm.emit()"
  (onCancel)="onCancel.emit()"
>
</app-payments-info-dialog>
